import React, { useState, useRef } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, TextArea } from '@ygtechnologies/bygr-frontend-component-library';
import { Trans } from '@lingui/react/macro';
import { triggerHandler } from '@ygtechnologies/rubus-frontend-utilities';
import { rejectOrder } from '@/services/orders';
import { Button } from '@/components/Buttons';
import { t } from '@lingui/core/macro';

interface OrderRejectDialogProps {
    show: boolean;
    orderId: number;
    onClose(): void;
    onReject(reason: string): void;
}

const OrderRejectDialog: React.FC<OrderRejectDialogProps> = ({ show, onClose, onReject, orderId }) => {
    const [reason, setReason] = useState('');
    const [saving, setSaving] = useState(false);

    const focusElementRef = useRef<HTMLTextAreaElement>(null);

    const handleOpen = () => {
        setReason('');

        if (focusElementRef.current) {
            focusElementRef.current.focus();
        }
    };

    const handleRejectClick = async () => {
        setSaving(true);

        try {
            await rejectOrder(orderId, reason);

            triggerHandler(onReject, reason);
            triggerHandler(onClose);
        } finally {
            setSaving(false);
        }
    };

    const handleCancelClick = () => {
        triggerHandler(onClose);
    };

    return (
        <Modal isOpen={show} toggle={handleCancelClick} onOpened={handleOpen}>
            <ModalHeader>
                <Trans>Reject Order</Trans>
            </ModalHeader>
            <ModalBody>
                <div className="form-group">
                    <label>
                        <Trans>Reason</Trans>
                    </label>
                    <TextArea
                        ref={focusElementRef}
                        value={reason}
                        name="reason"
                        className="form-control"
                        placeholder={t`Reason`}
                        onChange={(e) => setReason(e.target.value)}></TextArea>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="tertiary" onClick={handleCancelClick} disabled={saving}>
                    <Trans>Cancel</Trans>
                </Button>
                <Button color="danger" onClick={handleRejectClick} loading={saving}>
                    <Trans>Reject</Trans>
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default OrderRejectDialog;
